import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Draggable from "react-draggable";
import SaveIcon from "@material-ui/icons/Save";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import DeleteIcon from "@material-ui/icons/Delete";
import TextField from "@material-ui/core/TextField";
import { green, orange, red, grey } from "@material-ui/core/colors";
import PropTypes from "prop-types";

function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

const QuotaEditor = (props) => {
    const [newQuota, setNewQuota] = useState(null);
    const [newQuotaFreeUpgrade, setNewQuotaFreeUpgrade] = useState(null);
    const [overbooking, setOverbooking] = useState(null);

    const handleSubmit = () => {
        if (newQuotaFreeUpgrade !== null) {
            props.handleFreeUpgradeCount(newQuotaFreeUpgrade);
        } else {
            if (newQuota) {
                props.onSubmit(newQuota);
            } else if (overbooking || overbooking === 0) {
                props.onSubmit({ overbooking });
            }
        }
    };

    const keyDownHandler = (e) => {
        if (e.key === "Enter" && (newQuota >= 0 || overbooking >= 0 || newQuotaFreeUpgrade >= 0)) {
            handleSubmit();
        } else if (e.key === "Escape") {
            props.onClose();
        }
    };

    return (
        <div>
            <Dialog
                onKeyDown={keyDownHandler}
                open={props.isVisible}
                onClose={props.onClose}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                maxWidth="xl"
            >
                <DialogTitle
                    style={{ cursor: "move" }}
                    id="draggable-dialog-title"
                >
                    Введите новую квоту доступных номеров
                </DialogTitle>
                <DialogContent>
                    {!props?.getAsuParameters()?.isQuotaFromAsu ? (
                        <TextField
                            autoFocus
                            error={newQuota < 0}
                            helperText={
                                newQuota < 0
                                    ? "Значение не может быть отрицательным"
                                    : null
                            }
                            id="standard-number"
                            label="Квота номеров"
                            type="number"
                            onChange={(e) =>
                                setNewQuota(parseInt(e.target.value))
                            }
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    ) : (
                        <span
                            style={{
                                fontWeight: "bold",
                                color: "#d32f2f",
                                display: "contents",
                            }}
                        >
                            Квоты передаются из АСУ
                        </span>
                    )}
                    {props?.getAsuParameters()?.isOverbooking &&
                        props?.getAsuParameters()?.isQuotaFromAsu && (
                            <TextField
                                autoFocus
                                error={overbooking < 0}
                                helperText={
                                    overbooking < 0
                                        ? "Значение не может быть отрицательным"
                                        : null
                                }
                                id="standard-number"
                                style={{
                                    margin: "0 0 0 30px",
                                }}
                                label="Овербукинг"
                                type="number"
                                onChange={(e) =>
                                    setOverbooking(parseInt(e.target.value))
                                }
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        )}
                    <Button
                        onClick={props.handleSwitchReservations}
                        color="primary"
                        variant="contained"
                        endIcon={<ArrowBackIcon />}
                        style={{
                            backgroundColor: green[500],
                            margin: "10px 0 0 35px",
                        }}
                    >
                        {/*<Link style={{color: 'white', textDecoration: 'none'}} to="/hotels/1/reservations">Перейти к заявкам</Link>*/}
                        Перейти к заявкам
                    </Button>

                    {
                        props.checkFreeUpgradeRoomTypes() &&
                      <TextField
                        style={{marginLeft: '15px'}}
                        autoFocus
                        error={newQuotaFreeUpgrade < 0}
                        helperText={
                            newQuotaFreeUpgrade < 0
                              ? "Значение не может быть отрицательным"
                              : null
                        }

                        label="Бесплатный апгрейд"
                        type="number"
                        onChange={(e) =>
                          setNewQuotaFreeUpgrade(parseInt(e.target.value))
                        }
                        InputLabelProps={{
                            shrink: true,
                        }}
                      />
                    }
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={props.onClose}
                        color="primary"
                        variant="contained"
                        endIcon={<ArrowBackIcon />}
                        style={{ backgroundColor: orange[500] }}
                    >
                        Вернуться
                    </Button>

                    <Button
                        disabled={
                            (newQuota >= 0 || overbooking >= 0 || newQuotaFreeUpgrade >= 0) &&
                            (newQuota != null || overbooking != null || newQuotaFreeUpgrade != null)
                                ? false
                                : true
                        }
                        onClick={handleSubmit}
                        color="primary"
                        variant="contained"
                        endIcon={<SaveIcon />}
                        style={
                            (newQuota >= 0 && newQuota != null) ||
                            (overbooking >= 0 && overbooking != null) ||
                            (newQuotaFreeUpgrade >= 0 && newQuotaFreeUpgrade != null)
                                ? { backgroundColor: green[500] }
                                : { backgroundColor: grey[500] }
                        }
                    >
                        Сохранить
                    </Button>
                    <Button
                        onClick={() => props.closing(true)}
                        color="primary"
                        variant="contained"
                        endIcon={<DeleteIcon />}
                        style={{ backgroundColor: red[500] }}
                    >
                        Закрыть продажи
                    </Button>
                    <Button
                        onClick={() => props.closing(false)}
                        color="primary"
                        variant="contained"
                        endIcon={<SaveIcon />}
                        style={{ backgroundColor: green[500] }}
                    >
                        Открыть продажи
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

QuotaEditor.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    isVisible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default QuotaEditor;
